import React from "react";
import { Box, Card } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

const Datagrid = ({
  data,
  col,
  getRowId,
  height,
  showOptions,
  shadow,
  name,
}) => {
  return (
    <Card elevation={shadow ?? 2} sx={{ p: 0 }}>
      <Box sx={{ height: height ? { height } : 400, width: "100%" }}>
        <DataGrid
          getRowId={getRowId}
          rows={data}
          columns={col}
          disableRowSelectionOnClick
          slotProps={{
            toolbar: {
              csvOptions: {
                fileName: name ? name : "Data", // <-- Custom file name here
                utf8WithBom: true, // Optional: helps for Excel compatibility
              },
            },
          }}
          initialState={{
            sorting: {
              sortModel: [{ field: "commodity", sort: "asc" }], // Basic sorting
            },
          }}
          slots={{ toolbar: GridToolbar }} // Enables filtering, density, export
          sx={{
            backgroundColor: "white",
            borderRadius: 3,
          }}
        />
      </Box>
    </Card>
  );
};

export default Datagrid;
